import styled, { keyframes } from 'styled-components';

import Body from '../../atoms/Body';
import Button from '../../atoms/Button';
import Image from '../../atoms/Image';
import SVGIcon from '../../atoms/SVGIcon';
import ThemeV2 from '../../../theme';

const loaderAnimation = keyframes`
  0% { transform: rotate(0deg) };
  100% { transform: rotate(360deg) };
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-color: ${ThemeV2.palette.white};
  font-size: 16px;
`;

export const ErrorViewWrapper = styled.div`
  align-items: center;
  background-color: ${ThemeV2.palette.white};
  display: flex;
  flex-direction: column;
  height: 100vh;
  justify-content: center;
  text-align: center;
`;

export const ContentWrapper = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  max-width: 449px;
`;

export const LoaderContainer = styled.div`
  position: relative;
`;

export const Loader = styled.div`
  border-radius: 50%;
  width: 17em;
  height: 17em;
  margin-bottom: 2.5em;
  position: relative;
  border-top: 0.5em solid ${ThemeV2.palette.gray4};
  border-right: 0.5em solid ${ThemeV2.palette.gray4};
  border-bottom: 0.5em solid ${ThemeV2.palette.gray4};
  border-left: 0.5em solid ${ThemeV2.palette.volcano6};
  transform: translateZ(0);
  animation: ${loaderAnimation} 1.1s infinite linear;
`;

export const StyledImage = styled(Image)`
  position: absolute;
  width: 12.5em;
  top: 7.875em;
  left: 2.1875em;
`;

export const CatImage = styled(Image)`
  margin-bottom: 44px;
  width: 125px;
`;

export const ChromeStoreButton = styled(Button)`
  border-radius: 8px;
`;

export const CreateAssemblyAccountLink = styled.a`
  bottom: 0;
  display: flex;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  padding: 24px 32px;
  position: fixed;
  right: 0;
  color: ${ThemeV2.palette.gray7};

  &:hover,
  &:focus,
  &:active {
    color: ${ThemeV2.palette.gray7};
  }
`;

export const ErrorHeading = styled(Body)`
  margin-bottom: 4px;
`;

export const ErrorSubHeading = styled(Body)`
  margin-bottom: 24px;
`;

export const ExternalLinkIcon = styled(SVGIcon)`
  margin-right: 8px;
  width: 16px;
`;

export const FullAssemblyLogoIcon = styled(Image)`
  margin: 0px 4px;
  width: 92px;
`;

export const TryAgainButton = styled(Button)`
  border-radius: 8px;
  margin-bottom: 8px;
`;
